// extracted by mini-css-extract-plugin
export default {"hero_text":"HeroSection_hero_text__YwdN-","add_bg_img":"HeroSection_add_bg_img__zUGtM","hero_subText":"HeroSection_hero_subText__y-3M3"};